var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCompanyStore } from '../../../application/stores/company.store';
import { getCrossSellingItemsAsync } from '../../../application/usecases/getCrossSellingItems';
import { getCurrentServiceFormFilling } from '../../../application/usecases/getCurrentServiceFormFilling';
import GenericModal from '../../../components/common/Modals/GenericModal/GenericModal';
import { FormStatus } from '../../../contexts/FormProgressContext';
import { DocumentStatus } from '../../../types/DocumentationTypes';
import { scrollToTop } from '../../../utils/common-utils';
import GlobalContainer from '../../common/Containers/GlobalContainer';
import Footer from '../../common/Footer/Footer';
import Header from '../../common/Header/Header';
import Loader from '../../common/Loaders/Loader';
import ErrorComponent from '../Error/ErrorComponent';
import { ErrorEnum } from '../Error/ErrorEnum';
import { Section1Initial } from './sections/Section1Initial';
import { Section1Started } from './sections/Section1Started';
import { Section2 } from './sections/Section2';
import { Section3 } from './sections/Section3';
const Dashboard = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { company: { companyId, formStatus, documentGenerationStatus }, } = useCompanyStore();
    const [isLoading, setIsLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [cardNormatives, setCardNormatives] = useState();
    const [currentServiceFormFilling, setCurrentServiceFormFilling] = useState(null);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            setIsLoading(true);
            yield scrollToTop();
            const normativesList = yield getCrossSellingItemsAsync(companyId);
            const serviceFormFilling = yield getCurrentServiceFormFilling(companyId);
            const cards = (_a = normativesList === null || normativesList === void 0 ? void 0 : normativesList.map((item) => {
                const base = `dashboard.normatives.${item.key}`;
                return {
                    title: t(`${base}.title`),
                    subTitle: t(`${base}.subTitle`),
                    description: t(`${base}.description`),
                    urlForm: '',
                    icon: t(`${base}.icon`),
                };
            })) !== null && _a !== void 0 ? _a : [];
            setCardNormatives(cards);
            setCurrentServiceFormFilling(serviceFormFilling);
            setIsLoading(false);
        }))();
    }, []);
    const goToFormOrDocu = () => __awaiter(void 0, void 0, void 0, function* () {
        switch (formStatus) {
            case FormStatus.COMPLETED:
                if (documentGenerationStatus === DocumentStatus.ERROR || documentGenerationStatus === DocumentStatus.NOT_STARTED) {
                    navigate(`/document-generation/${currentServiceFormFilling === null || currentServiceFormFilling === void 0 ? void 0 : currentServiceFormFilling.id}`);
                }
                else {
                    navigate('/documentation');
                }
                break;
            case FormStatus.PENDING_EIPD:
                navigate(`/ot-list/${currentServiceFormFilling === null || currentServiceFormFilling === void 0 ? void 0 : currentServiceFormFilling.id}`);
                break;
            default:
                navigate('/form');
                break;
        }
    });
    const getButtonLiteral = () => {
        switch (formStatus) {
            case FormStatus.COMPLETED:
                return t('dashboard.btnGoToDocu');
            case FormStatus.NOT_STARTED:
            case FormStatus.NOT_CREATED:
                return t('dashboard.btnStartForm');
            case FormStatus.PENDING_EIPD:
            case FormStatus.IN_PROGRESS:
                return t('dashboard.btnContinueForm');
            default:
                return '';
        }
    };
    const handleClose = () => setOpenDialog(false);
    const masInfoForm = () => setOpenDialog(true);
    const isFormStarted = ![FormStatus.NOT_STARTED, FormStatus.NOT_CREATED].includes(formStatus);
    return (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsxs("title", { children: ["SIGNO | ", t('dashboard.title')] }) }), _jsxs(GlobalContainer, Object.assign({ className: "dashboard", withTitle: false }, { children: [_jsx(Header, {}), isLoading ? (_jsx(Loader, {})) : companyId ? (_jsxs("div", Object.assign({ className: "container-xl main-body-page dashboard px-0" }, { children: [isFormStarted ? (_jsx(Section1Started, { goToFormOrDocu: goToFormOrDocu, formStatus: formStatus, documentGenerationStatus: documentGenerationStatus })) : (_jsx(Section1Initial, { getButtonLiteral: getButtonLiteral, goToFormOrDocu: goToFormOrDocu })), _jsx(Section2, { cardNormatives: cardNormatives, masInfoForm: masInfoForm, formStatus: formStatus }), _jsx(Section3, { masInfoForm: masInfoForm })] }))) : (_jsx(ErrorComponent, { error: ErrorEnum.USER_PROFILE })), _jsx(Footer, {}), _jsx(GenericModal, Object.assign({ cssClass: "modal-mas-info-iframe", open: openDialog, title: t('formPage.modalSaveForm.title'), cssProps: { maxWidth: '450px' }, primaryAction: _jsx(Button, Object.assign({ onClick: handleClose, variant: "text", color: "primary" }, { children: t('common.btn.close') })) }, { children: _jsx("iframe", { className: "mas-info-iframe", src: "https://signo.conversia.es/formulario-de-venta-cruzada-de-signo/", width: "100%", height: "100%", allowFullScreen: true, title: "Formulario pedir m\u00E1s informaci\u00F3n" }) }))] }))] }));
};
export default Dashboard;
